import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum EamInventoryPermissionSet {
  View = 'eam_inventory_view', // Covers viewing inventory levels and transactions
  Adjust = 'eam_inventory_adjust', // Covers creating adjustments
}

export const eamInventoryPermissionSetGrouping: IPermissionSetGrouping<EamInventoryPermissionSet> = {
  key: PermissionSetGroupingKey.EamInventory,
  active: {
    [EamInventoryPermissionSet.View]: [
      PermissionType.GET_ANY_EAM_INVENTORY,
      PermissionType.RECEIVE_EAM_LOW_PARTS_INVENTORY_ALERT,
    ],
    [EamInventoryPermissionSet.Adjust]: [PermissionType.WRITE_ANY_EAM_INVENTORY_ADJUSTMENT],
  },
  unAssignablePermissionSets: [],
}
